'use client';

import React__default, { useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import styles from './SlideModal.module.css.js';
import closeIcon from './deleteIcon.js';

var SlideModal = function (props) {
    var isOpen = props.isOpen, onBack = props.onBack, title = props.title, titleStyle = props.titleStyle, headerStyle = props.headerStyle;
    var containerRef = useRef(null);
    useEffect(function () {
        var handleClickOutside = function (e) {
            var _a;
            var isClickOutside = !((_a = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target));
            if (isClickOutside) {
                onBack();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    useEffect(function () {
        var bodyNode = typeof document !== 'undefined' && (document === null || document === void 0 ? void 0 : document.querySelector('body'));
        if (!bodyNode) {
            return;
        }
        // Lock body scroll
        var removeOverflowClass = function () {
            document.body.classList.remove('overflow-hidden');
            document.documentElement.classList.remove('overflow-hidden');
        };
        // lock scrolling on body
        if (isOpen) {
            document.body.classList.add('overflow-hidden');
            document.documentElement.classList.add('overflow-hidden');
        }
        else {
            removeOverflowClass();
        }
        return function () {
            removeOverflowClass();
        };
    }, [isOpen]);
    /**
     * In Server side rendering case, document will be undefined
     */
    var bodyNode = typeof document !== 'undefined' && (document === null || document === void 0 ? void 0 : document.querySelector('body'));
    if (!bodyNode) {
        return null;
    }
    var classOpen = isOpen ? styles.isOpen : '';
    return ReactDOM.createPortal(React__default.createElement("div", null,
        React__default.createElement("div", { className: "".concat(styles.backdrop, " ").concat(classOpen) }),
        React__default.createElement("div", { className: "".concat(styles.container, " ").concat(classOpen), ref: containerRef },
            React__default.createElement("div", { className: styles.header, style: headerStyle },
                React__default.createElement("div", { className: styles.title, style: titleStyle }, title),
                React__default.createElement("div", { onClick: onBack, className: "".concat(styles.icon) },
                    React__default.createElement(closeIcon, null))),
            React__default.createElement("div", { className: styles.body }, props.children))), bodyNode);
};

export { SlideModal as default };
//# sourceMappingURL=SlideModal.js.map
